module.exports = __webpack_public_path__ + "img/HongKongTrust5.07a5fde0.png";